import { NavLink } from "react-router-dom";
import { INSTALLMENT_STATE_LABELS, SUBSCRIPTION_STATUS_LABELS, stateTone, statusTone } from "../../lib/billing";

export function SubscriptionStatusBadge({ status }) {
  return (
    <span className={`inline-flex items-center rounded-full border px-2 py-0.5 text-xs font-medium whitespace-nowrap ${statusTone(status)}`}
      data-testid={`billing-status-${status}`}>
      {SUBSCRIPTION_STATUS_LABELS[status] || status}
    </span>
  );
}

export function InstallmentStateBadge({ item }) {
  const label = INSTALLMENT_STATE_LABELS[item.state] || item.state;
  return (
    <span className={`inline-flex items-center rounded-full border px-2 py-0.5 text-xs font-medium whitespace-nowrap ${stateTone(item.state)}`}
      data-testid={`billing-state-${item.state}`}>
      {item.state === "overdue" ? `${label} · ${item.overdue_days} j` : label}
    </span>
  );
}

// The « Offres et abonnements » entry of the menu covers two lists, side by side.
export function RevenueTabs() {
  const tab = ({ isActive }) => `rounded-full px-3 py-1.5 text-sm font-medium whitespace-nowrap transition-colors ${
    isActive ? "bg-jamora text-white" : "bg-white text-slate-600 border border-slate-200 hover:bg-slate-50"}`;
  return (
    <nav className="flex gap-1" aria-label="Offres et abonnements" data-testid="billing-tabs">
      <NavLink to="/revenus/abonnements" className={tab} data-testid="billing-tab-subscriptions">Abonnements clients</NavLink>
      <NavLink to="/revenus/offres" className={tab} data-testid="billing-tab-offers">Offres</NavLink>
    </nav>
  );
}

export function Field({ label, children }) {
  return (
    <div className="flex flex-col sm:flex-row sm:items-baseline gap-0.5 sm:gap-3 py-1.5">
      <dt className="text-xs sm:text-sm text-slate-500 sm:w-32 shrink-0">{label}</dt>
      <dd className="text-sm text-slate-900 min-w-0 break-words">{children}</dd>
    </div>
  );
}
